// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__otoU0","adaptive":"Layout_adaptive__A8rPN","frame":"Layout_frame__Bnc1r","admin":"Layout_admin__Evioq"};